<div
  class="modal-overlay punksmarket-place-bid-modal"
  [class.active]="isActive">
  <div class="modal" *ngIf="isActive" (click)="$event.stopPropagation()">
    <button type="button" class="close-modal" (click)="step === 'success' ? finishSuccess() : closeModal()">x</button>

    <ng-container *ngIf="step === 'form'">
      <div class="modal-header">
        <h2><app-on-chain-bid-label>{{ placeOnChainBidButtonLabel }}</app-on-chain-bid-label></h2>
      </div>

      <ng-container *ngIf="isTargetedMode">
        <div class="punk-info">
          <p>
            Place an on-chain escrow bid for
            <strong>{{ environment.tokenName }} #{{ punkId }}</strong>.
            Only this punk can match your bid (allowlist).
          </p>
          <p class="hint">
            {{ onChainBidEscrowHint }}
          </p>
        </div>

        <div class="form-group">
          <label for="pm-bid-amount">Bid amount (Ξ)</label>
          <input
            type="number"
            id="pm-bid-amount"
            [(ngModel)]="bidAmountEth"
            placeholder="0"
            step="0.001"
            min="0" />
        </div>

        <div class="toggle-wrapper">
          <div class="sales-only-toggle settlement-reward-toggle" (click)="toggleSettlementReward()">
            <div class="label">Settlement reward for acceptor</div>
            <div class="toggle" [class.on]="showSettlementReward">
              <div></div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="showSettlementReward">
          <label for="pm-settlement-amount">Settlement reward (Ξ)</label>
          <input
            type="number"
            id="pm-settlement-amount"
            [(ngModel)]="settlementEth"
            placeholder="0"
            step="0.001"
            min="0" />
          <p class="field-hint">Optional tip paid to whoever settles your bid against a listing.</p>
        </div>

        <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

        <div class="form-actions">
          <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
          <button
            type="button"
            class="submit"
            (click)="submit()"
            [class.disabled]="submitting || !bidAmountEth || parseFloat(bidAmountEth) <= 0">
            {{ submitting ? 'Submitting…' : 'Place bid' }}
          </button>
        </div>
      </ng-container>

      <!-- Criteria mode: separate entry point later (not used from item page). -->
      <ng-container *ngIf="!isTargetedMode">
        <div class="punk-info">
          <p>Criteria-based bids are not available from this screen yet.</p>
        </div>
        <div class="form-actions">
          <button type="button" class="cancel" (click)="closeModal()">Close</button>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="step === 'success'">
      <div class="modal-header">
        <h2>Bid placed</h2>
      </div>

      <div class="success-content">
        <p class="success-icon" aria-hidden="true">✓</p>
        <p class="success-title">Your on-chain bid is live.</p>
        <p class="success-summary">
          <strong>{{ placedBidAmountEth }} Ξ</strong>
          escrowed for
          <strong>{{ environment.tokenName }} #{{ punkId }}</strong>.
        </p>
        <p
          class="success-detail"
          *ngIf="placedSettlementEth && parseFloat(placedSettlementEth) > 0">
          Settlement reward:
          <strong>{{ placedSettlementEth }} Ξ</strong>
        </p>
        <p class="hint">
          {{ onChainBidEscrowHint }}
        </p>
        <p class="success-tx" *ngIf="placedTxHash as txHash">
          Transaction:
          <a
            [href]="'https://etherscan.io/tx/' + txHash"
            target="_blank"
            rel="noopener noreferrer">
            {{ placedTxShortHash }}
          </a>
        </p>
      </div>

      <div class="form-actions form-actions--single">
        <button type="button" class="submit" (click)="finishSuccess()">Done</button>
      </div>
    </ng-container>
  </div>
</div>
